<template>
  <div class="transaction_list">
    <v-col class="pt-5">
      <div>
        <v-row>
          <v-col cols="12" md="3" class="py-0 pr-md-0">
            <profile-menu></profile-menu>
          </v-col>
          <v-col cols="12" md="9" class="pl-md-5 py-0 mt-5 mt-md-0">
            <v-row class="d-flex">
              <v-col cols="12" md="12">
                <div class="grey--text text--darken-1 text-body-2">
                  Link Afiliasi:
                  <span class="mr-4">{{ getUrlReferal(detailProfile.user_username) }}</span>
                  <input
                    type="hidden"
                    :value="getUrlReferal(detailProfile.user_username)"
                    id="inputCopy"
                  />
                  <span
                    class="primary--text cursor-pointer text-copy"
                    @click="copyme"
                    v-if="!loadingProfile"
                    >Salin</span
                  >
                  <span v-else>
                    <v-progress-circular
                      indeterminate
                      color="green"
                      :size="18"
                    ></v-progress-circular>
                  </span>
                </div>
              </v-col>
            </v-row>
            <div v-if="dataDownlineData.length == 0 && !dataDownlinePagination">
              <div class="pb-4">
                <v-card outlined elevation="0" class="py-3 rounded-lg">
                  <v-col class="pb-0">
                    <vcl :width="300" :height="65">
                      <rect x="0" y="0" rx="2" ry="2" width="60" height="5" />
                      <rect x="260" y="0" rx="2" ry="2" width="40" height="5" />
                      <rect x="5" y="15" rx="2" ry="2" width="80" height="5" />
                      <rect x="5" y="25" rx="2" ry="2" width="95" height="5" />
                      <rect x="5" y="35" rx="2" ry="2" width="155" height="10" />
                      <rect x="5" y="50" rx="2" ry="2" width="45" height="5" />
                      <rect x="70" y="50" rx="2" ry="2" width="45" height="5" />
                      <rect x="5" y="60" rx="2" ry="2" width="45" height="5" />
                      <rect x="70" y="60" rx="2" ry="2" width="45" height="5" />
                      <rect x="240" y="18" rx="2" ry="2" width="35" height="12" />
                      <rect x="220" y="34" rx="2" ry="2" width="75" height="12" />
                      <rect x="220" y="50" rx="2" ry="2" width="75" height="12" />
                    </vcl>
                  </v-col>
                </v-card>
              </div>
            </div>
            <div v-else-if="dataDownlineData.length == 0 && dataDownlinePagination">
              <v-card outlined elevation="0" class="py-3 rounded-lg">
                <v-row class="justify-center">
                  <v-col cols="7" md="5">
                    <v-img width="100%" src="/assets/icons/belum-ada-pesanan.svg"></v-img>
                  </v-col>
                </v-row>
                <div class="text-center pb-3">
                  <div class="pt-1 text-body-1 font-weight-bold">Belum ada data</div>
                  <div class="pt-1 text-body-2">
                    Sebarkan link afiliasimu dan dapatkan bonus belanja
                  </div>
                </div>
              </v-card>
            </div>
            <div v-else>
              <div class="pb-4" v-for="data in dataDownlineData" :key="data.user_id">
                <v-card outlined elevation="0" class="py-3 rounded-lg">
                  <v-row class="px-3">
                    <v-col class="py-1 text-body-2 my-auto">
                      <div class="d-block d-md-flex font-weight-bold">
                        <div class="pt-1 pt-md-0 pl-md-1">{{ data.user_username }}</div>
                      </div>
                    </v-col>
                  </v-row>
                  <div class="px-3 py-2">
                    <v-divider></v-divider>
                  </div>
                  <v-row class="pl-3 pl-md-5 pr-3">
                    <v-col cols="12" sm="7" md="8" class="pl-3 pl-md-5 py-0 text-body-2">
                      <div class="pt-3 d-md-flex">
                        <div class="pt-1 pt-md-0 d-flex">
                          <div class="pl-3 text-body-2 font-weight-bold">{{ data.user_name }}</div>
                        </div>
                      </div>
                      <div class="pt-3 d-md-flex">
                        <div class="pt-1 pt-md-0 d-flex">
                          <div class="pl-md-3 font-size-13 grey--text text--darken-1">
                            Generasi :
                          </div>

                          <div class="pl-3 text-body-2 font-weight-bold">
                            {{ data.sponsor_gen }}
                          </div>
                        </div>
                      </div>
                      <div class="pt-3 d-md-flex">
                        <div class="pt-1 pt-md-0 d-flex">
                          <div class="pl-md-3 font-size-13 grey--text text--darken-1">
                            Tgl. Daftar :
                          </div>
                          <div class="pl-3 text-body-2 font-weight-bold">
                            {{ data.user_input_datetime | tanggal }}
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="5" md="4" class="text-center text-md-right">
                      <v-img
                        v-if="data.user_image"
                        width="30"
                        height="30"
                        class="mx-auto rounded-circle"
                        :src="data.user_image ? data.user_image : '/assets/icons/default-toko.svg'"
                      ></v-img>
                      <v-avatar v-else color="black" size="100">
                        <v-icon dark size="100">mdi-account-circle</v-icon>
                      </v-avatar>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
              <v-row class="pt-4 justify-center" v-if="dataDownlinePagination.total_page > 1">
                <v-pagination
                  v-model="page"
                  @input="changePage"
                  :length="dataDownlinePagination.total_page"
                  class="elevation-0"
                ></v-pagination>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-col>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ProfileMenu from "@/components/layout/store/ProfileMenu";

export default {
  components: {
    ProfileMenu
  },
  data() {
    return {
      loadingProfile: false,
      domain: process.env.VUE_APP_DOMAIN,
      page: 1,
      limit: 5,
      params: [],
      sortBy: "user_id",
      sortDir: "DESC",
      invoice_selected: ""
    };
  },
  computed: {
    ...mapState("transaction", ["dataDownlineData", "dataDownlinePagination"]),
    ...mapState("profile", ["detailProfile", "response"])
  },
  methods: {
    ...mapActions("profile", ["getProfileDetail"]),
    ...mapActions("transaction", ["dataDownline"]),
    changePage(page) {
      this.page = page;
      this.dataDownline({
        limit: this.limit,
        page: this.page,
        params: this.params,
        sort: this.sortBy,
        dir: this.sortDir
      });
    },
    getUrlReferal(network_id) {
      return process.env.VUE_APP_DOMAIN + "/r/" + network_id;
    },
    copyme() {
      var copyText = document.getElementById("inputCopy");
      copyText.setAttribute("type", "text");
      copyText.select();
      try {
        document.execCommand("copy");
        setTimeout(function() {
          setTimeout(function() {
            document.querySelector(".text-copy").innerHTML = "Salin";
          }, 1000);
          document.querySelector(".text-copy").innerHTML = "Tersalin";
        }, 300);
      } catch (err) {
        alert("Oops, tidak dapat menyalin");
      }
      copyText.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    }
  },
  created() {
    this.getProfileDetail();
    this.$store.dispatch("setPageTitle", "Data Downline");
    this.dataDownline({
      limit: this.limit,
      page: this.page,
      params: this.params
    });
  }
};
</script>
